import React, { useEffect } from 'react';
import { DeleteFilled, PlusOutlined } from '@ant-design/icons';
import { Form, Input, Row, Col, Button } from 'antd';
import { t } from "i18next";
import { TicketModel } from "models/tickets";


interface Material {
    form?: any;
    materialsArray?:any
    setMaterialsArray?: any
    material?:any
    setMaterial?:any
    RoleId?: number
    disabled?: boolean;
    ticket?: TicketModel;
}
const AddMaterials = ({form, materialsArray, setMaterialsArray, material, setMaterial,RoleId, disabled = false, ticket}: Material)=> {

    const changeMaterial = (event: React.ChangeEvent<HTMLInputElement>) => {
        setMaterial(event.target.value);
    };
    const addMaterial = ()=>{
        if(material) {
            handleAddMaterial(material)
            setMaterial("")
        }
    }
    const deleteMaterial = (element:{name: string})=>{
        handleDeleteMaterial(element)
    }
    const handleAddMaterial = (material: string)=>{
        const newMaterial = { name: material };
        const updatedmaterialsArray = [...materialsArray, newMaterial];
        setMaterialsArray(updatedmaterialsArray);
        form.setFieldsValue({ term: updatedmaterialsArray });
      }
      const handleDeleteMaterial = (deleteElement:{name: string})=>{
        const updatedmaterialsArray = materialsArray.filter((element: { name: string; })=>element.name !== deleteElement.name)
        setMaterialsArray(updatedmaterialsArray);
        form.setFieldsValue({ term: updatedmaterialsArray });
      }
    return (
<Form.Item name="term" label={t("Ticket_Terms")} style={{ maxHeight: "200px", overflowY: "scroll", padding: "1rem"}}>
    <Row gutter={[8, 8]}>
        <Col xs={18} sm={20}>
            <Form.Item labelCol={{ span: 4 }} noStyle>
                <Input disabled={disabled} value={material} onChange={changeMaterial} />
            </Form.Item>
        </Col>
        <Col xs={6} sm={4}>
            <Button 
            type="primary"
            disabled={disabled}
            onClick={addMaterial}
            icon={<PlusOutlined style={{display: "flex", justifyContent: "center", alignItems: "center"}} />}
            >
            </Button>
        </Col>
    </Row>
    <div style={{ paddingTop: "10px" }}>
        {        
        RoleId !== 4 
        ? materialsArray?.map((element: { name: string }) => (
            <div key={element.name} style={{
                display: "flex",
                padding: "8px 12px",
                margin: "5px 0",
                backgroundColor: "#f9f9f9",
                border: "1px solid #ddd",
                borderRadius: "8px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.2s ease, background-color 0.3s ease",
                maxWidth: "90%",
            }}>
                <div style={{
                    flex: 1, 
                }}>
                    {element.name}
                </div>
                <Button
                    className="delete-report-button"
                    hidden={disabled}
                    type="primary"
                    style={{
                        width: "24px", 
                        height: "24px", 
                        borderRadius: "50%", 
                        padding: "0", 
                        display: "flex", 
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#ff4d4f",
                        color: "white", 
                        border: "none",
                    }}
                    onClick={() => deleteMaterial(element)}
                >
                    <DeleteFilled style={{ fontSize: "16px" }} />
                </Button>
            </div>
        )
        )
        : ticket?.terms?.map((element: { name: string }) => (
            <div key={element.name} style={{
                display: "flex",
                padding: "8px 12px",
                margin: "5px 0",
                backgroundColor: "#f9f9f9",
                border: "1px solid #ddd",
                borderRadius: "8px",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                transition: "transform 0.2s ease, background-color 0.3s ease",
                maxWidth: "90%",
            }}>
                <div style={{
                    flex: 1, 
                }}>
                    {element.name}
                </div>
                <Button
                    className="delete-report-button"
                    hidden={disabled}
                    type="primary"
                    style={{
                        width: "24px", 
                        height: "24px", 
                        borderRadius: "50%", 
                        padding: "0", 
                        display: "flex", 
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#ff4d4f",
                        color: "white", 
                        border: "none",
                    }}
                    onClick={() => deleteMaterial(element)}
                >
                    <DeleteFilled style={{ fontSize: "16px" }} />
                </Button>
            </div>
        )
        )
        }
    </div>
</Form.Item>

    );
}

export default AddMaterials;